export default __webpack_public_path__ + "static/media/roles_11.15aaa36b.png";